// useToolTip.ts
import { useContext } from "react";
import { ToolTipContext } from "@/providers/ToolTipProvider"; // adjust import path

export function useToolTip() {
  const context = useContext(ToolTipContext);
  if (!context) {
    // throw new Error("useToolTip must be used within a ToolTipProvider");
    console.warn("useToolTip must be used within a ToolTipProvider");
  }
  return context!;
}
